const SUCCESS = 'success';
const ERROR = 'error';

class Clipboard {
  constructor(text) {
    this.text = text;
    this.cbs = {
      [SUCCESS]: () => {},
      [ERROR]: () => {},
    };
  }

  on(event, cb) {
    this.cbs[event] = cb;
  }

  copy() {
    const el = document.createElement('textarea');
    el.value = this.text;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    const selected = document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;
    el.select();
    const successful = document.execCommand('copy');
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }

    if (successful) this.cbs[SUCCESS](this.text);
    else this.cbs[ERROR](this.text);
  }
}

const directive = {
  beforeMount(el, binding) {
    if (binding.arg === 'onSuccess') {
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_success = binding.value;
    } else if (binding.arg === 'onError') {
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_error = binding.value;
    } else {
      const clipboard = new Clipboard(binding.value);
      clipboard.on(SUCCESS, (text) => {
        // eslint-disable-next-line no-underscore-dangle
        const cb = el._vueClipboard_success;
        if (cb) {
          cb(text);
        }
      });
      clipboard.on(ERROR, (text) => {
        // eslint-disable-next-line no-underscore-dangle
        const cb = el._vueClipboard_error;
        if (cb) {
          cb(text);
        }
      });
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard = clipboard;
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_copy = clipboard.copy.bind(clipboard);
      // eslint-disable-next-line no-underscore-dangle
      el.addEventListener('click', el._vueClipboard_copy);
    }
  },
  update(el, binding) {
    if (binding.arg === 'onSuccess') {
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_success = binding.value;
    } else if (binding.arg === 'onError') {
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_error = binding.value;
    } else {
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard.text = binding.value;
    }
  },
  unmounted(el, binding) {
    if (binding.arg === 'onSuccess') {
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_success = null;
    } else if (binding.arg === 'onError') {
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_error = null;
    } else {
      // eslint-disable-next-line no-underscore-dangle
      el.removeEventListener('click', el._vueClipboard_copy);
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard = null;
      // eslint-disable-next-line no-underscore-dangle, no-param-reassign
      el._vueClipboard_copy = null;
    }
  },
};

export const CopyToClipboard = {
  install(Vue) {
    Vue.directive('clipboard', directive);
  },
};

export const clipboard = directive;
